import { Component, computed, Inject } from '@angular/core';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faLanguage } from '@fortawesome/free-solid-svg-icons';
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import { SignalService } from '../../core/services/signal.service';

//import { SwitchComponent } from '../../shared/switch.component/switch.component';

import { ReactiveFormsModule } from '@angular/forms';
import { MasterService } from '../../core/services/master.service';

@Component({
  selector: 'app-header',
  imports: [FontAwesomeModule, ReactiveFormsModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  standalone: true
})
export class HeaderComponent {
  faWhatsapp=faWhatsapp;
  //faSearch=faSearch;
  //faHome=faHome;

  s_compass = Inject(SignalService).player_compass;
  s_language = Inject(SignalService).header_language;
  
  box_language = computed(() => this.s_language())
  
  constructor(private _svcsignal: SignalService, 
              private _svcmaster: MasterService
            ) 
  {  }

  ngOnInit() {
    this.s_compass = this._svcsignal.player_compass;
    this._svcsignal.setValue("compass","home");
    this.s_language = this._svcsignal.header_language;
  }
  ngAfterViewRender() {
    this._svcsignal.setValue("compass","home");
  }
  
  navigate(p_destiny:string):void {
    this._svcmaster.navigate(p_destiny);
  }

  sidebar(p_action:string):void {
    this._svcmaster.trg_sidedar("sidebar_" + p_action);
  }

}
